<template>
  <div>
<doc-tex-table-area :id='basicInfo.contract_id' class="table-area-card" :key="texKey+'tex'"></doc-tex-table-area>
    <doc-table-card :can-edit="canEdit" :layout="item" @on-add="addDocumentMoney" @del-item="delItem" @edit-item="editItem" v-for="(item,index) in layout" :key="index">
    </doc-table-card>
    <!-- <a-card> -->

    <!-- </a-card> -->
    <a-modal :title="isEdit ? '编辑合同金额' : '新增合同金额'" v-model="visible" okText="保存" @ok="onSaveDocumentMoney" @cancel="handleCancel">
      <a-form class="doc-table-add-form" :form="form">
        <a-form-item v-bind="formItemLayout" label="服务费金额（含税）">
          <a-input-number v-decorator="[
            'cumul_service_fee_intax',
            {
              rules: [{required: true, type: 'number', message: '请输入服务费金额'}],
              initialValue:editData.service_fee_intax||editData.service_fee_intax===0?editData.service_fee_intax:'',
            }
          ]"></a-input-number>
        </a-form-item>

        <a-form-item v-bind="formItemLayout" label="PT费金额（含税）">
          <a-input-number v-decorator="[
              'cumul_pt_fee_intax',
              {
                rules: [{required: true, type: 'number', message: '请输入PT费金额'}],
                initialValue:editData.pt_fee_intax||editData.pt_fee_intax===0?editData.pt_fee_intax:'',
              }
            ]">
          </a-input-number>
        </a-form-item>

        <a-form-item v-bind="formItemLayout" label="合同金额（含税）">
          {{cumul_fee ? cumul_fee: ''}} (自动计算)
        </a-form-item>

        <a-form-item v-bind="formItemLayout" label="税率">
          <a-select v-if="taxList.length" v-decorator="[
              'amount_tax_rate',
              {
                rules: [{required: true, message: '请选择税率'}],
                initialValue: initialRate,
              },
            ]">
            <a-select-option v-for="tax in taxList" :key="tax.key" :value="tax.key">{{tax.val}}</a-select-option>
          </a-select>
        </a-form-item>

        <!--变更日期-->
        <a-form-item v-bind="formItemLayout" label="变更日期">
          <a-date-picker v-decorator="['amount_date_list', {rules: [{required: true, message: '请选择变更日期'}], initialValue:editData.amount_date?moment(editData.amount_date):undefined,}]">
            <a-icon slot="suffixIcon" :component="'SvgIcDate'" />
          </a-date-picker>
        </a-form-item>

        <a-form-item v-bind="formItemLayout" label="备注">
          <a-textarea v-decorator="[
            'amount_remark',
            {initialValue:editData.amount_remark?editData.amount_remark:'',}
          ]" :autoSize="{ minRows: 2, maxRows: 2 }">
          </a-textarea>
        </a-form-item>
      </a-form>

    </a-modal>
    <footer-btn v-if="basicInfo.curr_step_num<stepInfo.stepNum && canEdit" :btnText="btnText" @on-save="onSave" :noCancelBtn="true"></footer-btn>
  </div>
</template>

<script>
import moment from 'moment';
import {
  addContractAmount,
  contractAmountStatistic,
  contractAmountList,
  saveDocAmounts,
  editContractAmount,
  deleteContractAmount,
  getNextStepName,
  contractAmountOption
} from '../../services/DocService.js';
import SvgIcDate from '../../assets/svg/ic-date-o.svg';
import { amountToNumber } from '../../utils/tools.js';
import { DocTexTable } from '@/components/detailTableArea';

export default {
  props: {
    basicInfo: Object,
    canEdit: Boolean,
    stepInfo: Object
  },
  components: {
    SvgIcDate, DocTexTableArea: DocTexTable
  },
  methods: {
    moment,
    addDocumentMoney() {
      this.visible = true;
    },
    onSaveDocumentMoney() {
      this.form.validateFields((err, values) => {
        if (!err) {
          if (this.isEdit) {
            this.editAmount(values);
          } else {
            this.addAmount(values);
          }
        }
      });
    },

    getContractAmountOption() {
      contractAmountOption({ contract_id: this.basicInfo.contract_id }).then(
        (res) => {
          if (res.status === 'success') {
            this.taxList = res.data.amount_tax_rate_list;
            this.currentTaxRate = res.data.contract_tax_rate;
          }
        }
      );
    },

    queryAmountStatistic() {
      const params = {
        contract_id: this.basicInfo.contract_id,
        amount_type: 1
      };
      this.layout[0].loading = true;
      return contractAmountStatistic(params).then((res) => {
        if (
          res.status === 'success'
          && res.data.list
          && res.data.list.length > 0
        ) {
          res.data.list.forEach((item, index) => {
            item.key = index;
          });
          this.$data.layout[0].tableData = res.data.list;
        } else if (res.status === 'failed') {
          this.$Message.error(res.message);
        }
        this.layout[0].loading = false;
      });
    },
    queryAmountList() {
      const params = {
        contract_id: this.basicInfo.contract_id,
        amount_type: 1
      };
      this.layout[1].loading = true;
      return contractAmountList(params).then((res) => {
        if (res.status === 'success' && res.data) {
          if (res.data.length > 0) {
            res.data.forEach((item, index) => {
              item.key = index;
            });
          }
          this.$data.layout[1].tableData = res.data;
          this.texKey++;// 刷新合同金额-区分税码
        } else if (res.status === 'failed') {
          this.$Message.error(res.messgae);
        }
        this.layout[1].loading = false;
      });
    },

    addAmount(formData) {
      const params = {
        contract_id: this.basicInfo.contract_id,
        amount_type: 1,
        service_fee_intax: formData.cumul_service_fee_intax,
        pt_fee_intax: formData.cumul_pt_fee_intax,
        amount_date: formData.amount_date_list
          ? moment(formData.amount_date_list).format('YYYY-MM-DD')
          : undefined
      };
      if (formData.amount_remark) {
        params.amount_remark = formData.amount_remark;
      }
      params.amount_tax_rate = Number(formData.amount_tax_rate)
        ? formData.amount_tax_rate
        : this.currentTaxRate;

      return addContractAmount(params).then((res) => {
        if (res.status === 'success') {
          this.visible = false;
          this.texKey++;
          this.next_step = this.stepInfo.nextStepNum;
          this.form.resetFields();
          this.queryAmountList();
          this.queryAmountStatistic();
          this.$emit('update-doc');
          this.formCache = {
            cumul_service_fee_intax: 0,
            cumul_pt_fee_intax: 0
          };
        } else if (res.status === 'failed') {
          this.$Message.error(res.message);
        }
      });
    },

    editAmount(values) {
      const editParams = {
        service_fee_intax: values.cumul_service_fee_intax,
        pt_fee_intax: values.cumul_pt_fee_intax,
        amount_date: moment(values.amount_date_list).format('YYYY-MM-DD'),
        amount_remark: values.amount_remark,
        amount_tax_rate: Number(values.amount_tax_rate)
          ? values.amount_tax_rate
          : this.currentTaxRate
      };

      editContractAmount({
        amount_id: this.editData.amount_id,
        ...editParams
      }).then((res) => {
        if (res.status === 'success') {
          this.visible = false;
          this.isEdit = false;
          this.form.resetFields();
          this.queryAmountList();
          this.queryAmountStatistic();
          this.$emit('update-doc');
          this.next_step = this.stepInfo.nextStepNum;
          this.formCache = {
            cumul_service_fee_intax: 0,
            cumul_pt_fee_intax: 0
          };
          this.editData = {};
        } else {
          this.$Message.error(res.message);
        }
      });
    },

    onSave() {
      saveDocAmounts({
        contract_id: this.basicInfo.contract_id,
        amount_type: 1
      }).then((res) => {
        if (res.status === 'success') {
          this.$emit('change-step', {
            curr_step_num: this.stepInfo.stepNum,
            next_step: this.stepInfo.nextStepNum
          });
        } else if (res.status === 'failed') {
          this.$Message.error(res.message);
        }
      });
    },
    handleCancel() {
      this.form.resetFields();
      this.visible = false;
      this.editData = {};
      this.isEdit = false;
      this.formCache = {
        cumul_service_fee_intax: 0,
        cumul_pt_fee_intax: 0
      };
    },

    delItem(e) {
      this.$Modal.confirm({
        width: 480,
        title: '是否确认删除本条记录？',
        okText: '确认',
        onOk: () => {
          return deleteContractAmount({ amount_id: e.record.amount_id }).then(
            (res) => {
              if (res.status === 'success') {
                this.queryAmountList();
                this.queryAmountStatistic();
                this.$emit('update-doc');
              } else {
                this.$Message.error(res.message);
              }
            }
          );
        }
      });
    },

    editItem(record) {
      this.isEdit = true;
      const fields = _.cloneDeep(record);
      if (fields.service_fee_intax) {
        fields.service_fee_intax = amountToNumber(fields.service_fee_intax);
        this.formCache.cumul_service_fee_intax = fields.service_fee_intax = Number(
          fields.service_fee_intax
        );
      }
      if (fields.pt_fee_intax) {
        fields.pt_fee_intax = amountToNumber(fields.pt_fee_intax);
        this.formCache.cumul_pt_fee_intax = fields.pt_fee_intax = Number(
          fields.pt_fee_intax
        );
      }
      if (fields.amount_date) {
        fields.amount_date = moment(fields.amount_date);
      }

      this.editData = fields;
      this.visible = true;
    }
  },
  mounted() {
    if (this.stepInfo.nextStepName) {
      this.btnText.okText = `填写${this.stepInfo.nextStepName} →`;
    }
    this.queryAmountStatistic();
    this.queryAmountList();
    this.getContractAmountOption();
  },
  beforeCreate() {
    const that = this;
    this.form = this.$form.createForm(this, {
      onFieldsChange(props, fields) {
        if (fields.cumul_pt_fee_intax && !fields.errors) {
          that.formCache.cumul_pt_fee_intax = fields.cumul_pt_fee_intax.value;
        } else if (fields.cumul_service_fee_intax && !fields.errors) {
          that.formCache.cumul_service_fee_intax = fields.cumul_service_fee_intax.value;
        }
      }
    });
  },
  computed: {
    cumul_fee() {
      const cumul_service_fee_intax = Number(this.formCache.cumul_service_fee_intax)
        && Number(this.formCache.cumul_service_fee_intax) !== 'NaN'
        ? Number(this.formCache.cumul_service_fee_intax)
        : 0;
      const cumul_pt_fee_intax = Number(this.formCache.cumul_pt_fee_intax)
        && Number(this.formCache.cumul_pt_fee_intax) !== 'NaN'
        ? Number(this.formCache.cumul_pt_fee_intax)
        : 0;

      const sum = cumul_service_fee_intax + cumul_pt_fee_intax;
      return sum.toFixed(2);
    },

    initialRate() {
      // 软件协议税率能改（其他税率不能改）; 软件协议新增税率默认为 1046；
      if (this.isEdit) {
        const rateObj = this.taxList.find(
          v => v.val === this.editData.amount_tax_rate
        );
        return rateObj && rateObj.key;
      }

      if (this.basicInfo.contract_type === 4) {
        return 14;
      }
      const findResult = this.taxList.find(
        v => v.key === this.currentTaxRate
      );
      return findResult && findResult.key;
    }
  },
  data() {
    const columns = [
      {
        title: '变更日期',
        dataIndex: 'amount_date',
        // width: 160
      },
      {
        title: '修改人',
        dataIndex: 'creator_name',
        // width: 100
      },
      {
        title: '税率',
        dataIndex: 'amount_tax_rate',
        // width: 80
      },
      {
        title: '服务费',
        dataIndex: 'service_fee_extax',
        // width: 100
      },
      {
        title: 'PT费',
        dataIndex: 'pt_fee_extax',
        // width: 100
      },
      {
        title: '合同金额',
        dataIndex: 'fee_extax',
        // width: 100
      },
      {
        title: '服务费（含税）',
        dataIndex: 'service_fee_intax',
        // width: 100
      },
      {
        title: 'PT费（含税）',
        dataIndex: 'pt_fee_intax',
        // width: 100
      },
      {
        title: '合同金额（含税）',
        dataIndex: 'fee_intax',
        // width: 140
      },
      {
        title: '备注',
        dataIndex: 'amount_remark',
        // width: 180
      },
      {
        title: '操作',
        dataIndex: 'operation',
        width: 80,
        scopedSlots: { customRender: 'operation' }
      }
    ];
    // if (this.basicInfo.contract_type !== 4) {
    //   columns.splice(2, 1);
    // }

    return {
      texKey: 1,
      btnText: {
        cancelText: '取消',
        okText: '保存'
      },
      formCache: {
        cumul_service_fee_intax: 0,
        cumul_pt_fee_intax: 0
      },
      visible: false,
      next_step: 0,
      currentTaxRate: 0,
      formItemLayout: {
        labelCol: { span: 10 },
        wrapperCol: { span: 12 }
      },
      taxList: [],
      editData: {},
      layout: [
        {
          hasAdd: false,
          cardTitle: '合同金额',
          hasStatistical: false,
          tableColumns: [
            {
              title: '费用类型',
              dataIndex: 'type'
            },
            {
              title: '服务费',
              dataIndex: 'service_fee'
            },
            {
              title: 'PT费',
              dataIndex: 'pt_fee'
            },
            {
              title: '合同金额',
              dataIndex: 'fee'
            }
          ],
          tableData: [],
          loading: false
        },
        {
          hasAdd: true,
          addText: '新增合同金额',
          cardTitle: '变更记录',
          hasStatistical: false,
          tableColumns: columns,
          tableData: [],
          loading: false
        }
      ],

      isEdit: false
    };
  }
};
</script>

<style lang="less">
.doc-money-change-record {
  margin-top: 16px;
}
.table-area-card{
  background:#fff;
.detail-table_title-container{
  padding:0 24px;
  padding-top:24px;
}
.detail-table_table{
  padding:24px;
  border-top: 1px solid #e8e8e8;
}
}
</style>
